import { CaseTemplate, UserAccount } from "../data/types";
import { useCallback, useEffect, useRef } from "react";
import SignalRServiceManager from "./SignalRServiceManager";

type CaseTemplateSignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertCaseTemplate?: (caseTemplate: CaseTemplate) => void;
}
export const useCaseTemplateSignalR = (props: CaseTemplateSignalRProps) => {
    const { primaryAccount, onUpsertCaseTemplate } = props;
    const messageName = "upsertCaseTemplate";

    // Use useRef to maintain stable reference
    const onUpsertCaseTemplateRef = useRef(onUpsertCaseTemplate);

    useEffect(() => {
        onUpsertCaseTemplateRef.current = onUpsertCaseTemplate;
    }, [onUpsertCaseTemplate]);

    const upsertHandler = useCallback((caseTemplateJson: string) => {
        try {
            const caseTemplate = JSON.parse(caseTemplateJson);
            onUpsertCaseTemplateRef.current?.(caseTemplate);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, caseTemplateJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}